import { render } from "./PaymentWallet.vue?vue&type=template&id=d28ee5a2"
import script from "./PaymentWallet.vue?vue&type=script&lang=js"
export * from "./PaymentWallet.vue?vue&type=script&lang=js"

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__